const isUspsGroupTheme = (theme)=>{
    return [
        'default',
        'light',
        'sunglasses'
    ].includes(theme);
};

export { isUspsGroupTheme };
//# sourceMappingURL=types.js.map
